export const words = {
  en: {
    general: {
      Title: `<span class="hide-sm">ECPM - </span>Our <b>interactive map</b>`,
      News: `Latest news`,
      LastExecution: `Last execution`,
      ExecutionMethod: `Current method(s) of execution`,
      PeopleDeathRow: `Persons currently sentenced to death`,
      MoreInformation: `More information`,
      MoreInfo: `More info`,
      Op2Ratification: `Ratification of the OP2`,
      NotRatified: `not ratified`,
      InFavour: `In favour`,
      Against: `Against`,
      Abstention: `Abstention`,
      Absence: `Absence`,
      UniversalMoratoriumVoteLegendTitle: `Vote for the universal moratorium`,
      UniversalMoratoriumVoteLegend: `Universal moratorium vote`,
      UniversalMoratoriumVoteLegendMobile: `Universal moratorium`,
      Op2RatificationLegendMobile: `OP2`,
      UniversalMoratoriumVote: `Vote for a universal moratorium`,
      SpecificCharge: `Among the charges :`,
      Terrorism: `Terrorism`,
      Homosexuality: `Homosexuality`,
      LinkHomosexuality: `https://www.ecpm.org/en/campaigns-in-progress/the-death-penalty-is-homophobic/`,
      ExecutionsNumber: `Number of executions`,
      CondemnationsNumber: `Number of death sentences`,
      Sources: `Sources`,
      AbolitionYear: `Year of the abolition`,
      GeocoderPlaceholder: `Search for a country...`,
      LegendLabel: `States status`,
      Abolitionist: `Abolitionist`,
      CommonRightAbolitionist: `Abolitionist for ordinary crimes`,
      // Moratoire: `Moratorium`,
      Moratoire: `With a moratorium on executions`,
      Retentionist: `Retentionist`,
      EcpmActions: `ECPM on the spot`,
      StatusLabel: `Status`,
      PlaceLabel: `Place`,
      Estimated: `estimated`,
      ToggleLegendDescription: `About death penalty status`,
      ToggleLegendUNDescription: `About UN instruments`
    },
    legendDefinition: {
      Abolitionist: `States or territories where the death penalty is abolished`,
      CommonRightAbolitionist: `States or territories where the death penalty is abolished unless there are exceptional circumstances`,
      Moratoire: `States or territories where the death penalty is implemented but no executions have been carried out for at least 10 years and which did not oppose the latest UN resolution for a universal moratorium on executions and/or having ratified OP2`,
      Retentionist: `States or territories where the death penalty is implemented`,
      MoratoriumLabel: `THE UN RESOLUTION FOR A UNIVERSAL MORATORIUM ON THE USE OF THE DEATH PENALTY`,
      Op2Label: `Second Optional Protocol to the International Covenant on Civil and Political Rights (OP2)`,
      MoratoriumDescription: `Since 2007, a resolution for a universal moratorium on the use of the death penalty has been submitted for vote at the UN General Assembly (UNGA) every two years. Through this text, which has been adopted by a large majority of States on every occasion, the UN reaffirms that application of the death penalty is an attack on human dignity “and calls upon all the States which maintain it to establish a moratorium on executions”.`,
      Op2Description: `The OP2 is the only international treaty providing for the total abolition of the death penalty. It was adopted and proclaimed by the United Nations General Assembly resolution 44/128 of 15 December 1989. Abstract: “No one within the jurisdiction of a State Party to the present Protocol shall be executed. Each State Party shall take all necessary measures to abolish the death penalty within its jurisdiction.” (Article 1)`,
      MoratoriumMoreInfo: `https://www.ecpm.org/en/campaigns-in-progress/moratorium-campaign/`,
      Op2MoreInfo: `https://www.ohchr.org/EN/ProfessionalInterest/Pages/2ndOPCCPR.aspx`
    },
    legendLabel: {
      Favorable: `Votes in favour of adopting the resolution`,
      Against: `Votes against adopting the resolution`,
      Abstentions: `Abstentions`,
      Absences: `Absences`,
      Ratified: `Ratified`,
      NotRatified: `Not ratified`,
    },
    hint: {
      ShowEcpm: `Show ECPM worldwide actions`,
      TogglePanel: `Toggle the info panel`,
      ShowTimeline: `Show the timeline`,
      ToggleSearchBar: `Toggle the search bar`,
      ToggleLegend: `Toggle the legend`,
      MessageShowMapInFullscreen: `For a better experience, navigate into the map in fullscreen`,
      ShowMapInFullscreen: `Show the map in fullscreen`,
      IframeIntegration: `Embed this map inside your website`,
    },
    navbar: {
      Status: `The death penalty worldwide`,
      Treaty: `Human Rights Instruments`
    },
    executionMethod: {
      Fusillade: 'Shooting',
      Pendaison: 'Hanging',
      Lapidation: 'Stoning',
      Decapitation: 'Beheading',
      InjectionLetale: 'Lethal injection',
      ChaiseElectrique: 'Electric chair',
      ChambreGaz: 'Gas chamber'
    },
    map: {
      Sources: `The data comes from the various reports of ECPM and its partners and the Amnesty International annual report on the death penalty`
    },
    mobile: {
      SelectMap: `Select a map`,
      Language: `Language`
    },
    share: {
      ShareThisMap: `Share this webmap`,
      OnTheSocialMedias: `On the social medias`,
      EmbedThisMap: `in your website`,
      CopyIframe: `Copy the iframe`,
      ShareOnTwitter: `Share on Twitter`,
      ShareOnFacebook: `Share on Facebook`,
      ShareOnLinkedin: `Share on LinkedIn`,
    },
    igo: {
      ButtonLarge: `Choose an Intergovernmental Organisation...`,
      ButtonSmall: `Choose an IGO`,
      WorldView: `World view`
    }
  },
  fr: {
    general: {
      Title: `<span class="hide-sm">ECPM - </span>Notre <b>carte interactive</b>`,
      News: `Dernières actualités`,
      LastExecution: `Dernière exécution`,
      ExecutionMethod: `Méthode(s) d’exécution en vigueur`,
      PeopleDeathRow: `Personnes actuellement condamnées à mort`,
      MoreInformation: `More information`,
      MoreInfo: `Plus d'informations`,
      Op2Ratification: `Ratification de l'OP2`,
      NotRatified: `non ratifié`,
      InFavour: `Favorable`,
      Against: `Contre`,
      Abstention: `Abstention`,
      Absence: `Absent`,
      UniversalMoratoriumVoteLegendTitle: `Vote pour un moratoire universel`,
      UniversalMoratoriumVoteLegend: `Vote pour un moratoire universel`,
      UniversalMoratoriumVoteLegendMobile: `Moratoire universel`,
      Op2RatificationLegendMobile: `OP2`,
      UniversalMoratoriumVote: `Vote pour un moratoire universel`,
      SpecificCharge: `Parmi les chefs d’accusation :`,
      Terrorism: `Terrorisme`,
      Homosexuality: `Homosexualité`,
      LinkHomosexuality: `https://www.ecpm.org/campagnes-en-cours/peine-de-mort-et-lgbt/`,
      ExecutionsNumber: `Nombre d'exécutions`,
      CondemnationsNumber: `Nombre de condamnations`,
      Sources: `Sources`,
      AbolitionYear: `Année de l'abolition`,
      GeocoderPlaceholder: `Rechercher un pays...`,
      LegendLabel: `Statuts des États`,
      Abolitionist: `Abolitionniste`,
      CommonRightAbolitionist: `Abolitionniste de droit commun `,
      Moratoire: `En moratoire`,
      Retentionist: `Rétentionniste`,
      EcpmActions: `ECPM sur le terrain`,
      StatusLabel: `Statut`,
      PlaceLabel: `Lieu`,
      Estimated: `estimée(s)`,
      ToggleLegendDescription: `À propos des différents statuts`,
      ToggleLegendUNDescription: `À propos des instruments onusiens`
    },
    legendDefinition: {
      Abolitionist: `États ou territoires où la peine de mort est abolie pour tous les crimes`,
      CommonRightAbolitionist: `États ou territoires où la peine de mort est abolie sauf circonstances exceptionnelles`,
      Moratoire: `États ou territoires où la peine de mort est en vigueur mais où aucune exécution n’a eu lieu depuis dix ans et ne s’opposant pas à la dernière résolution des Nations unies en faveur d’un moratoire universel sur les exécutions et/ou ayant ratifié l’OP2`,
      Retentionist: `États ou territoires appliquant la peine de mort`,
      MoratoriumLabel: `LA RESOLUTION POUR UN MORATOIRE UNIVERSEL SUR L’APPLICATION DE LA PEINE DE MORT À L’ONU`,
      Op2Label: `Deuxième protocole facultatif se rapportant au Pacte international relatif aux droits civils et politiques (OP2)`,
      MoratoriumDescription: `Depuis 2007, une résolution pour un moratoire universel sur l’application de la peine de mort est soumise au vote de l’Assemblée générale des Nations unies (AGNU) tous les deux ans. À travers ce texte, adopté à chaque fois par une large majorité d’États, l’Onu réaffirme que l’application de la peine de mort porte atteinte à la dignité humaine et « appelle tous les États qui la maintiennent encore à instituer un moratoire sur les exécutions ».`,
      Op2Description: `L’OP2 est le seul traité international prévoyant l’abolition totale de la peine de mort. Il a été adopté et proclamé par l'Assemblée générale de l’ONU dans sa résolution 44/128 du 15 décembre 1989. Extrait : « Aucune personne relevant de la juridiction d'un Etat partie au présent Protocole ne sera exécutée. Chaque Etat partie prendra toutes les mesures voulues pour abolir la peine de mort dans le ressort de sa juridiction. » (Article premier)`,
      MoratoriumMoreInfo: `https://www.ecpm.org/campagnes-en-cours/campagne-moratoire/`,
      Op2MoreInfo: `https://www.ohchr.org/FR/ProfessionalInterest/Pages/2ndOPCCPR.aspx`
    },
    legendLabel: {
      Favorable: `Votes en faveur l'adoption de la résolution`,
      Against: `Votes contre l'adoption de la résolution`,
      Abstentions: `Abstentions`,
      Absences: `Absences`,
      Ratified: `Ratifié`,
      NotRatified: `Non ratifié`
    },
    hint: {
      ShowEcpm: `Montrer les actions d'ECPM dans le monde`,
      TogglePanel: `Afficher le volet d'informations`,
      ShowTimeline: `Afficher la timeline`,
      ToggleSearchBar: `Afficher la barre de recherche`,
      MessageShowMapInFullscreen: `Pour une meilleure expérience, découvrez la carte en plein écran`,
      ShowMapInFullscreen: `Afficher la carte en plein écran`,
      IframeIntegration: `Intégrer cette carte à l'intérieur de votre site`,
    },
    navbar: {
      Status: `La peine de mort dans le monde`,
      Treaty: `Instruments des droits de l’homme`
    },
    executionMethod: {
      Fusillade: `Fusillade`,
      Pendaison: `Pendaison`,
      Lapidation: `Lapidation`,
      Decapitation: `Décapitation`,
      InjectionLetale: `Injection létale`,
      ChaiseElectrique: `Chaise électrique`,
      ChambreGaz: `Chambre à gaz`
    },
    map: {
      Sources: `Les données sont issues des différents rapports d'ECPM et de ses partenaires et du rapport annuel sur la peine de mort d'Amnesty International`
    },
    mobile: {
      SelectMap: `Sélectionnez une carte`,
      Language: `Langue`
    },
    share: {
      ShareThisMap: `Partager cette carte`,
      OnTheSocialMedias: `Sur les réseaux sociaux`,
      EmbedThisMap: `dans votre site web`,
      CopyIframe: `Copier l'iframe`,
      ShareOnTwitter: `Partager sur Twitter`,
      ShareOnFacebook: `Partager sur Facebook`,
      ShareOnLinkedin: `Partager sur LinkedIn`
    },
    igo: {
      ButtonLarge: `Sélectionner une Organisation intergouvernementale...`,
      ButtonSmall: `Sélectionner une OI`,
      WorldView: `Vue mondiale`
    }
  }
}